<script>
export default {
  name: 'MkButton',
};
</script>

<template>
  <i-button v-bind="$attrs" class="mk-button" v-on="$listeners">
    <slot />
  </i-button>
</template>

<style scoped lang="less">
@import '~@/assets/css/main.less';
@import '~@/assets/fonts/font.less';
.ivu-btn {
  border-radius: 18px;
}
.ivu-btn-default {
  border: 1px solid @app-color;
  border-radius: 18px;
  color: @app-color;
  &:hover {
    opacity: 0.9;
  }
  &[disabled] {
    border: 1px solid @app-color;
    border-radius: 18px;
    color: @app-color;
    opacity: 0.4;
    &:hover {
      opacity: 0.3;
    }
  }
}
.ivu-btn-primary {
  border-radius: 18px;
  background: @app-color;
  color: #ffffff;
  &:hover {
    opacity: 0.9;
  }
  &[disabled] {
    border-radius: 18px;
    background: @app-color;
    color: #ffffff;
    opacity: 0.4;
    &:hover {
      opacity: 0.3;
    }
  }
}
</style>
